import { Search,AccountHeadDetails } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-grievence-addressing',
  templateUrl: './grievence-addressing.component.html',
  styleUrls: ['./grievence-addressing.component.css']
})
export class GrievenceAddressingComponent implements OnInit {
  title ="Grievance Lodging";
  GrievancesLodging: any={};  
  UserName: string;
  RoleName: string;
  fileToUpload: File;
  formInvalid: boolean;
  fileNotUploaded:boolean;
  mode: any;
  Id: any;  
  userlist:any=[];
  GrievanceAlertDetails: any=[];
  g: any;
  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) {
    
   }
  ngOnInit() {
    this.UserName=localStorage.getItem('userName');
    // this.route.params.subscribe(params => {      
    //   this.mode = params['mode'];
    //   this.Id = params['Id'];
    // });
 //From URL
    this.mode=localStorage.getItem('mode');
    this.Id = localStorage.getItem('grievanceId');
    localStorage.removeItem('grievanceId'); 
    localStorage.removeItem('mode');
    
    if (this.mode=='view' || this.mode=='edit')
    {
      if (this.mode=='view')
      this.title="View Grievance";
      else
      this.title="Update Grievance";
      this.GetGrievanceById(this.Id);
    }

    this.GetAllUsersForGrievance();
    
  }

  GetGrievanceById(Id:number)
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getGrievanceById(this.Id)
      .subscribe(
        (data) => {
          this.GrievancesLodging = data; 
          this.GrievanceAlertDetails=this.GrievancesLodging.GrievanceAlertDetails; 
          if (this.GrievancesLodging.GR_TS != null)
          this.GrievancesLodging.GR_TS = ((this.GrievancesLodging.GR_TS).split('T'))[0]; 
          console.log(this.GrievanceAlertDetails);   
          if (this.mode=='edit') 
          {
            this.GrievancesLodging.ActionTaken="";
            this.GrievancesLodging.status="";
            this.GrievancesLodging.ForwardToUserId="";
            this.GrievancesLodging.ActionStatus="";
          }  
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  UpdateGrievances(sg:NgForm)
  {
    
    if (!sg.invalid)
    {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.GrievancesLodging.Id=this.Id;
      this.userService.UpdateSainikGrievances(this.GrievancesLodging).subscribe((response)=>{
        document.getElementById('loader-spinner').style.display = "none";
        swal("Success!","Grievance Status Updated Successfully",'success');
        this.router.navigate(['/home/ga']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      }); 
    }       
      else
      {
        document.getElementById('loader-spinner').style.display = "none";
        this.formInvalid = true;        
      }
    }



    GetAllUsersForGrievance()
    {
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.getAllUsersForGrievance()
        .subscribe(
          (data) => {
            this.userlist = data;
            //swal("warning",this.sainikSchemeApplicationModel.ID);
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
        });
    }

    cancel()
    {
      debugger;
      this.GrievancesLodging.ForwardToUserId='',
      this.GrievancesLodging.ActionStatus='',
      this.GrievancesLodging.status='',
      this.GrievancesLodging.ActionTaken=''
      // this.GrievancesLodging.ActionTaken='',
      // this.GrievancesLodging.ActionTaken='',
      // this.GrievancesLodging.ActionTaken='',
      // this.GrievancesLodging.ActionTaken='',
    }
    

}



// WEBPACK FOOTER //
// ./src/app/Grievances-Addressing/grievence-addressing/grievence-addressing.component.ts